import { useMemo } from 'react';
import {
  useApi,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { createCitationEnhancer } from '../utils/citations/enhancement';

/**
 * Hook for fetching and enhancing citations with devportal links
 */
export const useCitedFiles = () => {
  const discoveryApi = useApi(discoveryApiRef);
  const fetchApi = useApi(fetchApiRef);

  const citationEnhancer = useMemo(
    () => createCitationEnhancer({ discoveryApi, fetchApi }),
    [discoveryApi, fetchApi],
  );

  return {
    enhanceCitations: citationEnhancer.enhanceCitations,
  };
};
